import { DTDataGridAlignment, DTDataGridColumnType } from "../../models/IDataColumn";
import {IExpression, IPackage} from "../../models/configuration/plugin/IConfiguration";
import { IDataColumn } from "../ui/dataGrid";
import { DtExpandableText } from "../ui/text";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DtStatusCell from "../ui/status/DtStatusCell";

export const evaluationResultsColumns = (): Array<IDataColumn> => {
    return [
    {
        name: "Control Type",
        fieldId: "controlType",
        datatype: 'text',
        readonly: true,
        sortable:true
    },
    {
        name: "Id",
        fieldId: "id",
        datatype: 'text',
        readonly: true,
        sortable:true
    },
    {
        name: "Group",
        fieldId: "group",
        datatype: 'text',
        readonly: true,
        sortable:true
    },
    {
        name: "Message",
        fieldId: "message",
        datatype: 'text',
        readonly: true,
        sortable:true
    },
    {
        name: "Result",
        fieldId: "result",
        datatype: 'text',
        readonly: true,
        width: 15,
        renderCell: (row: any, rowIndex: number) => {
            const isSuccess = row?.result;
            return <DtStatusCell
                exists={isSuccess}
                yesText=""
                noText=""
                noIcon={<CancelIcon />}
            />
        }
    }
    ];
};

export const validDeliveryMethodsColumns = (): Array<IDataColumn> => {
    return [
    {
        name: "Enabled",
        fieldId: "Enabled",
        datatype: 'checkbox',
        readonly: true,
        width: 10
    },
    {
        name: "Group",
        fieldId: "Group",
        datatype: 'text',
        readonly: true,
        sortable: true,
    },
    {
        name: "Package",
        fieldId: "Id",
        datatype: 'text',
        readonly: true,
        sortable: true
    },
    {
        name: "Valid Delivery Types",
        fieldId: "ValidDeliveryTypes",
        datatype: 'text',
        readonly: true,
        sortable: true,
        width: 45,
        renderCell: (row: IPackage, rowIndex: number) => {
            let deliveryTypesText = '';

            if (row.ValidDeliveryTypes && Array.isArray(row.ValidDeliveryTypes)) {
                deliveryTypesText = row.ValidDeliveryTypes.join(', ');
            } else if (row.ValidDeliveryTypes) {
                deliveryTypesText = String(row.ValidDeliveryTypes);
            }
            return <DtExpandableText value={deliveryTypesText} showToggleLabel={false} previewLength={130}/>;
        }
       
    }
    ];
};